import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

const OverviewChartSideMenuScala = ({maxValue, unitsRenderer}) => (
  <div className="OverviewChart__sideMenu__marks">
    <div>{unitsRenderer(maxValue, maxValue)}</div>
    <div>{unitsRenderer(maxValue * 0.75, maxValue)}</div>
    <div>{unitsRenderer(maxValue * 0.5, maxValue)}</div>
    <div>{unitsRenderer(maxValue * 0.25, maxValue)}</div>
    <div>{unitsRenderer(0, maxValue)}</div>
  </div>
);

const ChartSideMenuTotalCell = ({group, maxValue}) => {
  const dataTip = JSON.stringify({
    label: 'Total',
    date: group.totalRoomsDate,
    totalRooms: maxValue
  });

  return (
    <div
      data-tip={dataTip}
      data-for="ChartSideMenu__tooltip"
      className="OverviewChart__sideMenu__table__row OverviewChart__sideMenu__table__row--with-shadow colab-centered-h">
      <div className="OverviewChart__sideMenu__table__row__title colab-bold">
        Total
      </div>
      <div className="OverviewChart__sideMenu__table__row__roomCount">
        {maxValue} rooms
      </div>
    </div>
  );
};

class ChartSideMenuHeaderCell extends React.Component<any> {
  render() {
    const {group} = this.props;
    const dataTip = JSON.stringify({
      label: group.label,
      date: group.totalRoomsDate,
      totalRooms: group.totalRooms
    });

    return (
      <React.Fragment>
        <div
          data-tip={dataTip}
          data-for="ChartSideMenu__tooltip"
          className={classNames(
            'OverviewChart__sideMenu__table__row OverviewChart__sideMenu__table__row--with-shadow colab-centered-h',
            {'colab-clickable': !_.isEmpty(group.nestedElements)}
          )}>
          <div className="OverviewChart__sideMenu__table__row__title colab-bold">
            {group.label}
          </div>
          {(group.totalRooms || _.isNumber(group.totalRooms)) && (
            <div className="OverviewChart__sideMenu__table__row__roomCount">
              {_.round(group.totalRooms)} rooms
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const OverviewChartSideMenu = ({
  tableHeaderData,
  unitsRenderer,
  totalRooms
}) => (
  <div className="OverviewChart__sideMenu">
    <OverviewChartSideMenuScala
      unitsRenderer={unitsRenderer}
      maxValue={totalRooms}
    />
    <div className="OverviewChart__sideMenu__table">
      <ChartSideMenuTotalCell
        maxValue={totalRooms}
        group={tableHeaderData[0] || {}}
      />
      {tableHeaderData.map(group => (
        <ChartSideMenuHeaderCell key={group.label} group={group} />
      ))}
    </div>
  </div>
);

export default OverviewChartSideMenu;
